import axios from 'axios'

const PRODUCTS_ENDPOINT = "https://developertests.z33.web.core.windows.net/ReactTestData.json"

const http = {
	async fetchProducts() {
		try {
			const data = (await axios.get(PRODUCTS_ENDPOINT)).data
			return {
				data,
				error: false,
			}
		}
		catch (error) {
			return {
				error: error.response
			}
		}
	}
}

export default http